(() => {
  const script = document.currentScript;
  const localeRoot = (script?.dataset.localeRoot || '/').replace(/\/$/, '');
  const languageRoots = (script?.dataset.languageRoots || '')
    .split(',').map(root => root.replace(/\/$/, '')).filter(Boolean)
    .sort((a, b) => b.length - a.length);
  const contentPath = /^\/(?:$|pages(?:\/|$)|blogs(?:\/|$)|collections(?:\/|$)|products(?:\/|$)|policies(?:\/|$)|search(?:\/|$))/;

  function localizeLink(link) {
    if (!(link instanceof HTMLAnchorElement) || link.matches('[data-no-localize], [hreflang], [download]')) return;
    const href = link.getAttribute('href');
    if (!href || /^(?:#|mailto:|tel:|javascript:)/i.test(href)) return;
    let url;
    try { url = new URL(href, window.location.href); } catch { return; }
    if (url.origin !== window.location.origin) return;
    let path = url.pathname;
    const previousRoot = languageRoots.find(root => path === root || path.startsWith(root + '/'));
    if (previousRoot) path = path.slice(previousRoot.length) || '/';
    if (!contentPath.test(path)) return;
    url.pathname = localeRoot + path;
    const localized = url.pathname + url.search + url.hash;
    if (href !== localized) link.setAttribute('href', localized);
  }

  function localizeAllLinks(root) {
    if (root instanceof HTMLAnchorElement) localizeLink(root);
    root.querySelectorAll?.('a[href]').forEach(localizeLink);
  }

  localizeAllLinks(document);
  for (const eventName of ['click', 'auxclick', 'contextmenu']) {
    document.addEventListener(eventName, event => {
      if (event.target instanceof Element) localizeLink(event.target.closest('a[href]'));
    }, true);
  }
  new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') localizeLink(mutation.target);
      else mutation.addedNodes.forEach(node => {
        if (node instanceof Element) localizeAllLinks(node);
      });
    }
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['href']
  });

  document.querySelectorAll('.dmc-language-switcher__form').forEach(form => {
    form.addEventListener('submit', () => {
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    });
  });
})();
